import { render, staticRenderFns } from "./SModal.vue?vue&type=template&id=6cccbeb0&"
import script from "./SModal.vue?vue&type=script&lang=js&"
export * from "./SModal.vue?vue&type=script&lang=js&"
import style0 from "./SModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports